import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const GatheredPants = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.pants.GatheredPants.itemName}
      name={SS23.pants.GatheredPants.itemName}
      price={SS23.pants.GatheredPants.itemPrice}
      fabric={SS23.pants.GatheredPants.itemFabric}
      src={SS23.pants.GatheredPants.sizeChart}
      divId={SS23.pants.GatheredPants.shopifyDivId}
      mainId={SS23.pants.GatheredPants.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.pants.GatheredPants.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.pants.GatheredPants.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default GatheredPants;
